import { render } from "./TMovimientosIndex.vue?vue&type=template&id=23258b53"
import script from "./TMovimientosIndex.vue?vue&type=script&lang=js"
export * from "./TMovimientosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/TMovimientosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23258b53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23258b53', __exports__)) {
    api.reload('23258b53', __exports__)
  }
  
  module.hot.accept("./TMovimientosIndex.vue?vue&type=template&id=23258b53", () => {
    api.rerender('23258b53', render)
  })

}


export default __exports__